// extracted by mini-css-extract-plugin
module.exports = {"capycha-action":"src-components-common-province-validator-anhui-captcha-__index__capycha-action--3eNN9"};